import ClubPresentation from './pages/ClubPresentation';
import Clubs from './pages/Clubs';
import Calendrier from './pages/Calendar';
import Classement from './pages/Classement';
import {listClubProam, listClubProbm, listClubProad, listClubProbd } from './variables';
import DetailsClub from './pages/DetailsClub';

const cPresentation = [
    {path: 'proam/presentation', component: <ClubPresentation championnat='proam' />},
    {path: 'probm/presentation', component: <ClubPresentation championnat='probm' />},
    {path: 'proad/presentation', component: <ClubPresentation championnat='proad' />},
    {path: 'probd/presentation', component: <ClubPresentation championnat='probd' />},
]

const cClubs = [
    {path: 'proam/clubs', component: <Clubs championnat='proam' />},
    {path: 'probm/clubs', component: <Clubs championnat='probm' />},
    {path: 'proad/clubs', component: <Clubs championnat='proad' />},
    {path: 'probd/clubs', component: <Clubs championnat='probd' />},
]

const cJoueurs = [
    {path: 'proam/joueurs', component: <Clubs to='joueurs' championnat='proam' />},
    {path: 'probm/joueurs', component: <Clubs to='joueurs' championnat='probm' />},
    {path: 'proad/joueurs', component: <Clubs to='joueurs' championnat='proad' />},
    {path: 'probd/joueurs', component: <Clubs to='joueurs' championnat='probd' />},
]

const champCalendrier = [
    {path: 'proam/calendrier', component: <Calendrier championnat='proam' />},
    {path: 'probm/calendrier', component: <Calendrier championnat='probm' />},
    {path: 'proad/calendrier', component: <Calendrier championnat='proad' />},
    {path: 'probd/calendrier', component: <Calendrier championnat='probd' />},
]

const champClassement = [
    {path: 'proam/classement', component: <Classement championnat='proam' />},
    {path: 'probm/classement', component: <Classement championnat='probm' />},
    {path: 'proad/classement', component: <Classement championnat='proad' />},
    {path: 'probd/classement', component: <Classement championnat='probd' />},
]


export const pages = [
    {id: 1, page: cPresentation},
    {id: 2, page: cClubs},
    {id: 3, page: cJoueurs},
    {id: 3, page: champCalendrier},
    {id: 4, page: champClassement},
]



export const initializeClubPage = () => {
    let arrayDetailsClub = [];

    // Pages details des clubs
    listClubProam.forEach(function(club) {
        const objClub = {path: 'proam/'+club.short, component: <DetailsClub championnat='proam' club={club} />}
        arrayDetailsClub.push(objClub);
    })
    listClubProbm.forEach(function(club) {
        const objClub = {path: 'probm/'+club.short, component: <DetailsClub championnat='probm' club={club} />}
        arrayDetailsClub.push(objClub);
    })
    listClubProad.forEach(function(club) {
        const objClub = {path: 'proad/'+club.short, component: <DetailsClub championnat='proad' club={club} />}
        arrayDetailsClub.push(objClub);
    })
    listClubProbd.forEach(function(club) {
        const objClub = {path: 'probd/'+club.short, component: <DetailsClub championnat='probd' club={club} />}
        arrayDetailsClub.push(objClub);
    })
    pages.push({id: 5, page: arrayDetailsClub});
}




